var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgTips = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M47.993 26.411c-10.524 0-19.585 9.061-19.585 19.585 0 6.833 4.655 13.575 10.058 16.939.176 5.366 0 15.456 0 15.88 0 .529 2.117 6.88 10.057 6.88 6.352 0 8.645-4.587 8.998-6.88v-15.88c5.696-3.295 10.058-9.886 10.058-16.939 0-10.524-9.061-19.585-19.585-19.585Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M38.068 70.37H57.93M51.789 33.738a9.632 9.632 0 0 1 6.755 5.23M51.175 69.743c-1.42-15.386 3.334-20.683 4.193-22.798a.168.168 0 0 0-.236-.207c-1.099.634-4.055 1.942-7.032-.216a.165.165 0 0 0-.193 0c-2.977 2.158-5.934.85-7.032.216a.166.166 0 0 0-.236.207c.852 2.116 5.59 7.407 4.17 22.798"
  }), React.createElement("path", {
    fill: color,
    d: "M38.443 70.721h19.588v5.876c0 5.41-4.385 9.794-9.794 9.794-5.41 0-9.794-4.385-9.794-9.794v-5.876Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M44.213 75.577h7.575M45.159 80.31h5.68"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M67.957 46.001c0-12.098-10.77-21.682-23.24-19.694-8.54 1.36-15.294 8.285-16.477 16.854-1.184 8.569 3.071 16.224 9.79 20.111a.08.08 0 0 1 .04.07V76.65a9.1 9.1 0 0 0 9.101 9.102h1.657a9.102 9.102 0 0 0 9.102-9.102V63.342a.081.081 0 0 1 .04-.07 19.932 19.932 0 0 0 9.987-17.27ZM79.035 46H84M12 46h4.965M48 14.965V10M69.944 24.056l3.512-3.51M22.545 71.456l3.51-3.512M26.055 24.056l-3.51-3.51M73.456 71.456l-3.512-3.512"
  }));
};
export default SvgTips;